/* system-cms-prefix start */
const prefix = '/cmsmanager'
/* system-cms-prefix change const prefix = '/cmsadmin' system-cms-prefix change */
/* system-cms-prefix end */

export default {
  // 内容搜索列表
  contentextPage: `${prefix}/contentext/page`,
  // 排序列表
  contentextOrder: `${prefix}/contentext/orders`,
  // 回收站列表
  contentextRecycle: `${prefix}/contentext/recycle`,
  // 归档列表
  contentextPigeonhole: `${prefix}/contentext/pigeonhole`,
  // 查询模板列表
  contentTemplateList: `${prefix}/content/template/list`,
  // 内容/附件密级列表
  contentSecretList: `${prefix}/content/secret/list`,
  // 来源列表
  contentSourceList: `${prefix}/content/source/list`,
  // 发文字号列表
  contentMarkList: `${prefix}/content/mark/list`,
  // 可新建内容栏目列表
  contentChannelList: `${prefix}/content/channel/list`,
  // 内容模型-所有
  contentModelList: `${prefix}/content/model/list`,
  // 删除内容（逻辑删除）、还原内容
  contentext: `${prefix}/contentext`,
  // 删除内容（加入回收站）
  contentextRubbish: `${prefix}/contentext/rubbish`,
  // 改变内容状态
  contentextStatus: `${prefix}/contentext/status`,
  // 出档
  contentextFile: `${prefix}/contentext/file`,
  // 内容类型点击操作
  contentextOperation: `${prefix}/contentext/operation`,
  // 置顶
  contentextTop: `${prefix}/contentext/top`,
  // 取消置顶
  contentextNotop: `${prefix}/contentext/notop`,
  // 移动
  contentextMove: `${prefix}/contentext/move`,
  // 排序
  contentextSort: `${prefix}/contentext/sort`,
  // 引用内容
  contentextQuote: `${prefix}/contentext/quote`,
  // 取消引用
  contentextNoquote: `${prefix}/contentext/noquote`,
  // 新增时渲染内容结构
  contentPlus: `${prefix}/content/plus`,
  // 新增内容，查询，修改
  content: `${prefix}/content`,
  // 复制内容
  contentDuplication: `${prefix}/content/duplication`,
  // 推送到站群
  contentPushSites: `${prefix}/content/push/sites`,
  // 版本-分页
  contentVersionPage: `${prefix}/contentVersion/page`,
  // 版本-新增，修改，删除
  contentVersion: `${prefix}/contentVersion`,
  // 版本-对比
  contentVersionCompare: `${prefix}/contentVersion/compare`,
  // 版本-回复
  contentVersionRecovery: `${prefix}/contentVersion/recovery`,
  // 操作记录
  contentrecordPage: `${prefix}/contentrecord/page`,
  // 灰色站栏目id合集
  channelRecycleIds: `${prefix}/channel/recycle/ids`,
  // 相关内容-列表
  contentrelationPage: `${prefix}/contentrelation/page`,
  // 相关内容-关联、删除
  contentrelation: `${prefix}/contentrelation`,
  // 相关内容-排序
  contentrelationSort: `${prefix}/contentrelation/sort`,
  // 微博推送预览
  weiboarticlepushPreview: `${prefix}/weiboarticlepush/preview`,
  // 查看流程图信息
  taskProcessDiagram: `${prefix}/task/processDiagram`,
  // 查看内容审核记录
  taskActions: `${prefix}/task/actions`,
  // 查询是否工作流
  channelWorkflowBeing: `${prefix}/channel/workflow/being`,
  // 校验内容标题是否可以使用
  contentTitleUnique: `${prefix}/content/title/unique`,
  // 撤回审核
  taskRevoke: `${prefix}/task/revoke`,
  // 内容提交审核
  contentSubmit: `${prefix}/content/submit`,
  // 栏目默认设置
  channelDefaults: `${prefix}/channel/defaults`,
  // 清空回收站
  contentextClearAll: `${prefix}/contentext/clearAll`,
  // 用户使用模型记录
  contentModelRecord: `${prefix}/content/model/record`,
  // 内容智能审核搜索列表
  contentextChackPage: `${prefix}/contentext/chack/page`,
  // 内容智能审核 审核内容数量
  contentextChackAmount: `${prefix}/contentext/chack/amount`,
  // 是否显示强制发布按钮
  contentForceButton: `${prefix}/content/force/button`,
  // 处理文档（文库文档转换）
  contentConversionDoc: `${prefix}/content/conversion/doc`,
  // 获取按钮树形
  contentButton: `${prefix}/content/button`,
  // 内容浏览记录
  contentRecord: `${prefix}/content/view/record`,
  // 访问地域表格
  contentTable: `${prefix}/content/view/table`,
  // 内容管理-内容列表(全部)
  contentListData: `${prefix}/contentType/list`
}
